import { Component, HostListener, OnInit } from '@angular/core';
import { CazaOportunidadModel } from '../../models/cazaOportunidad.model';
import { SearchService } from '../../services/search.service';
import { CargaInicial, Estado, BusquedaCiudad, Ciudad, BusquedaColonia, TipoInmueble } from '../../models/InmuebleSearch.model.response';
import { BusquedaInmueble } from '../../models/InmuebleSearch.model.response';
import { InmuebleResponse } from '../../models/InmueblesResponse';
import { CazaOportunidadService } from '../../services/caza-oportunidad.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { ValidadoresCazaOportunidadService } from '../../services/validadoresCazaOportunidad.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { zip } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  standalone: false
})
export class SearchComponent implements OnInit {

  option: any;

  //BUSQUEDA
  cargaInicial: CargaInicial = new CargaInicial();
  cargaciudad: BusquedaCiudad = new BusquedaCiudad();
  busquedaCiudad: BusquedaCiudad = new BusquedaCiudad();
  busquedaColonia: BusquedaColonia = new BusquedaColonia();
  coloniaFiltro: BusquedaColonia = new BusquedaColonia();
  ciudadesSeleccionadas: Ciudad[] = [];
  coloniasSeleccionadas: string[] = [];
  estados: Estado[];
  est: Estado = new Estado();
  cdd: Ciudad = new Ciudad();
  tipoVenta: number = 0;
  formBusqueda: any = UntypedFormGroup;
  Todos: any;
  cleaning: boolean = false;

  selectedItem: TipoInmueble[] = [];
  selectedEstado: Estado[] = [];

  openedSelect: string = '';

  tipoInmuebleRotation: number = 0;
  rangoRotation: number = 0;
  estadoRotation: number = 0;
  ciudadRotation: number = 0;

  selectedTipoInmuebleText: string = '';
  selectedRangoText: string = '';
  selectedEstadoText: string = '';
  selectedCiudadText: string = '';

  constructor(private searchService: SearchService,
    private formBuilder: UntypedFormBuilder,
    private validarores: ValidadoresCazaOportunidadService,
    private routes: Router, private activeRoute: ActivatedRoute) {
    this.crearFormularioBusqueda();
  }

  ngOnInit() {
    this.searchService.obtenerEstados().subscribe((data) => {
      this.cargaInicial = data.respuesta;
      this.selectedItem = this.cargaInicial.tiposInmuebles;
      this.selectedEstado = this.cargaInicial.estados;

      const tipoInmueble = localStorage.getItem('tipoInmueble');
      const estado = localStorage.getItem('estado');
      const ciudades = localStorage.getItem('ciudadesSeleccionadas');
      const rango = localStorage.getItem('rango');

      if (tipoInmueble) {
        const tipo = this.selectedItem.find(t => t.idTipoInmueble === Number(tipoInmueble));
        if (tipo) {
          this.formBusqueda.get('tipoInmueble').setValue(tipo.idTipoInmueble);
          this.selectedTipoInmuebleText = tipo.nombre;
        }
      }

      if (estado) {
        const estadoParsed: Estado = JSON.parse(estado);
        const estadoEncontrado = this.selectedEstado.find(e => e.idEstado === estadoParsed.idEstado);
        if (estadoEncontrado) {
          this.formBusqueda.get('estado').setValue(estadoEncontrado);
          this.selectedEstadoText = estadoEncontrado.nombre;
          this.getCiudades(estadoEncontrado);
        }
      }

      if (rango) {
        const rangoVal = Number(rango);
        this.formBusqueda.get('rango').setValue(rangoVal);
        const textoRango = this.obtenerTextoRango(rangoVal);
        this.selectedRangoText = textoRango;
      }
    });

    this.formBusqueda.get('estado').valueChanges.subscribe((estadoSeleccionado: Estado) => {
      this.selectedCiudadText = '';
      this.formBusqueda.get('ciudad').setValue('');
      this.ciudadesSeleccionadas = [];
      this.busquedaColonia = new BusquedaColonia();
      this.getCiudades(estadoSeleccionado);
    });
  }

  getCiudades(estadoSeleccionado: Estado) {
    console.log(estadoSeleccionado);
    if (!estadoSeleccionado) {
      return;
    }
    console.log(estadoSeleccionado.nombre);
    console.log("ciudades seleccionadas length" + this.ciudadesSeleccionadas.length);
    if (this.ciudadesSeleccionadas.length > 0) {
      this.limpiarCiudadesYColonias();
    }

    this.busquedaCiudad = new BusquedaCiudad();
    this.busquedaColonia = new BusquedaColonia();

    const ciudadesLS = localStorage.getItem('ciudadesSeleccionadas');
    if (ciudadesLS && ciudadesLS !== null) {
      this.ciudadesSeleccionadas = JSON.parse(ciudadesLS);
    }

    if (estadoSeleccionado.nombre !== undefined) {
      this.searchService.ciudadEst((estadoSeleccionado as Estado).idEstado, null, 0).subscribe((data) => {
        this.busquedaCiudad = data.respuesta;

        if (this.ciudadesSeleccionadas.length > 0 && this.busquedaCiudad.ciudades?.length > 0) {
          const ciudadGuardada = this.ciudadesSeleccionadas[0];
          const ciudadEncontrada = this.busquedaCiudad.ciudades.find(c => c.idCiudad === ciudadGuardada.idCiudad);
          if (ciudadEncontrada) {
            this.formBusqueda.get('ciudad').setValue(ciudadEncontrada);
            this.selectedCiudadText = ciudadEncontrada.nombre;
          }
        }
        console.log(this.busquedaCiudad);
      });
    } else {
      this.busquedaCiudad = new BusquedaCiudad();
      this.busquedaColonia = new BusquedaColonia();
      this.ciudadesSeleccionadas = [];
      this.coloniasSeleccionadas = [];
    }
  }

  ciudadesSeleccion(item: Ciudad, isCom?) {
    if (item == null || item.nombre === undefined) {
    this.ciudadesSeleccionadas = [];
    this.coloniasSeleccionadas = [];
    this.busquedaColonia = new BusquedaColonia();
    return;
  }

    this.ciudadesSeleccionadas = [item];

    this.cdd = item;
    this.busquedaColonia = new BusquedaColonia();
    this.coloniasSeleccionadas = [];

    this.getColonias([item]);

    this.cleaning = false;
  }

  getColonias(listSeleccionados: Ciudad[]) {
    this.searchService.coloniaCiudad(this.cdd.idCiudad, (this.formBusqueda.get('estado').value as Estado).idEstado,
      this.formBusqueda.get('tipoVenta').value, this.formBusqueda.get('tipoInmueble').value).subscribe((data) => {
        this.busquedaColonia = data.respuesta;
      });
  }

  searchCiudad(lista: Ciudad[], item: Ciudad) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < lista.length; i++) {
      if (lista[i].nombre === item.nombre) {
        return true;
      }
    }
    return false;
  }

  coloniasSeleccion(item: string, isCom?) {
    if (this.searchColonia(this.coloniasSeleccionadas, item) && !isCom) {
      this.coloniasSeleccionadas = this.coloniasSeleccionadas.filter((it) => {
        return it !== item && it !== '';
      });
    } else if (!this.searchColonia(this.coloniasSeleccionadas, item) && item !== 'Todos' && item != null) {
      this.coloniasSeleccionadas.push(item);
    }

    if (item === 'Todos') {
      this.coloniasSeleccionadas = [];
    }
  }

  searchColonia(lista: string[], item: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < lista.length; i++) {
      if (lista[i] === item) {
        return true;
      }
    }
    return false;
  }

  buscar() {
    let buscar: BusquedaInmueble = new BusquedaInmueble();
    let rangoAux: number;

    buscar.idTipoInmuble = this.formBusqueda.get('tipoInmueble').value;
    rangoAux = this.formBusqueda.get('rango').value;
    buscar.idEstado = (this.formBusqueda.get('estado').value as Estado).idEstado;
    buscar.listaCiudades = this.validarores.generarListIdsCiudades(this.ciudadesSeleccionadas);
    buscar.listaColonias = this.coloniasSeleccionadas;

    if (rangoAux == 1) {
      buscar.precioMinimo = 0;
      buscar.precioMaximo = 500000;
    } else if (rangoAux == 2) {
      buscar.precioMinimo = 500000;
      buscar.precioMaximo = 1000000;
    } else if (rangoAux == 3) {
      buscar.precioMinimo = 1000000;
      buscar.precioMaximo = 3000000;
    } else if (rangoAux == 4) {
      buscar.precioMinimo = 3000000;
      buscar.precioMaximo = 5000000;
    } else if (rangoAux == 5) {
      buscar.precioMinimo = 5000000;
      buscar.precioMaximo = 9999999999999;
    }
    if (buscar.precioMinimo === 0 && buscar.precioMaximo === 0) {
      buscar.precioMinimo = null;
      buscar.precioMaximo = null;
    }
    // @ts-ignore
    buscar.palabraClave = this.formBusqueda.get('palabraClave').value;
    if (buscar.palabraClave === '') {
      buscar.palabraClave = null;
    }
    // @ts-ignore
    buscar.tipoVenta = this.formBusqueda.get('tipoVenta').value;

    localStorage.setItem('tipoInmueble', this.formBusqueda.get('tipoInmueble').value);
    localStorage.setItem('estado', JSON.stringify(this.formBusqueda.get('estado').value as Estado));
    localStorage.setItem('ciudadesSeleccionadas', JSON.stringify(this.ciudadesSeleccionadas));
    localStorage.setItem('rango', rangoAux?.toString());

    localStorage.setItem('page', null);
    localStorage.setItem('filters', null);
    this.routes.navigate(['inmuebles'], {
      state: { buscar: btoa(JSON.stringify(buscar)) },
      queryParams: { buscar: btoa(JSON.stringify(buscar)) }, relativeTo: this.activeRoute
    });
    //this.searchService.obtenerInmuebles(buscar).subscribe(data => console.log(data));
  }

  limpiar() {
    this.cleaning = true;
    this.cdd = new Ciudad();
    this.est = new Estado();
    this.busquedaCiudad = new BusquedaCiudad();
    this.busquedaColonia = new BusquedaColonia();
    this.ciudadesSeleccionadas = [];
    this.selectedItem = [];//AEA
    this.selectedEstado = [];//AEA
    this.coloniasSeleccionadas = [];
    this.formBusqueda.reset({
      tipoInmueble: ['', Validators.required],
      rango: [0],
      estado: ['', Validators.required],
      ciudad: [''],
      tipoVenta: [0],
      palabraClave: [''],
      terreno: [0],
      construccion: [0],
      precioMinimo: ['$0'],
      precioMaximo: ['$0']
    });
  }

  limpiarCiudadesYColonias() {
    this.cdd = new Ciudad();
    this.busquedaCiudad = new BusquedaCiudad();
    this.busquedaColonia = new BusquedaColonia();
    this.ciudadesSeleccionadas = [];
    this.coloniasSeleccionadas = [];
    this.formBusqueda.patchValue({
      ciudad: ['']
    });
  }

  /*
  Se asignan elementos de la vista al formulario reactivo
   */
  crearFormularioBusqueda() {
    this.formBusqueda = this.formBuilder.group({
      tipoInmueble: ['', Validators.required],
      rango: [0],
      estado: ['', Validators.required],
      ciudad: [''],
      tipoVenta: [0],
      palabraClave: [''],
      terreno: [0],
      construccion: [0],
      precioMinimo: ['$0'],
      precioMaximo: ['$0']
    });
  }

  convertir(value: string) {
    return Number(value.replace(/[^0-9\.]+/g, ""));
  }

  onChange(newValue) {
    this.searchService.obtenerTipoInmuebleFiltrados(newValue).subscribe((data) => {
      this.selectedItem = data.respuesta;
    });
  }

  onChangeInmueble(newValue) {
    this.tipoVenta = this.formBusqueda.get('tipoVenta').value;
    /* this.searchService.obtenerEst(this.formBusqueda.get('tipoVenta').value, this.convertir(newValue)).subscribe((data) => {
      this.selectedEstado = data.respuesta;
    }); */
  }

  obtenerTextoRango(valor: number): string {
    switch (valor) {
      case 1: return '$0 a $500,000';
      case 2: return '$500,000 a $1,000,000';
      case 3: return '$1,000,000 a $3,000,000';
      case 4: return '$3,000,000 a $5,000,000';
      case 5: return 'Mayor a $5,000,000';
      default: return '';
    }
  }

  toggleSelect(field: string) {
    const wasOpen = this.openedSelect === field;
    const previouslyOpened = this.openedSelect;

    if (wasOpen) {
      this.openedSelect = '';
      this.updateRotation(field);
    } else {
      if (previouslyOpened) {
        this.updateRotation(previouslyOpened);
      }
      this.openedSelect = field;
      this.updateRotation(field);
    }
  }

  private updateRotation(field: string) {
    switch (field) {
      case 'tipoInmueble':
        this.tipoInmuebleRotation -= 180;
        break;
      case 'rango':
        this.rangoRotation -= 180;
        break;
      case 'estado':
        this.estadoRotation -= 180;
        break;
      case 'ciudad':
        this.ciudadRotation -= 180;
        break;
    }
  }

  toggleTipoInmueble() {
    this.toggleSelect('tipoInmueble');
  }

  toggleRango() {
    this.toggleSelect('rango');
  }

  toggleEstado() {
    this.toggleSelect('estado');
  }

  toggleCiudad() {
    this.toggleSelect('ciudad');
  }

  selectTipoInmueble(tipo: TipoInmueble) {
    this.selectedTipoInmuebleText = tipo.nombre;
    this.formBusqueda.get('tipoInmueble').setValue(tipo.idTipoInmueble);
    this.onChangeInmueble(tipo.idTipoInmueble);
    this.toggleTipoInmueble();
  }

  selectRango(valor: number, texto: string) {
    this.selectedRangoText = texto;
    this.formBusqueda.get('rango').setValue(valor);
    this.toggleRango();
  }

  selectEstado(estado: Estado) {
    localStorage.removeItem('ciudadesSeleccionadas');
    this.selectedEstadoText = estado.nombre;
    this.formBusqueda.get('estado').setValue(estado);
    this.getCiudades(estado);
    this.toggleEstado();
  }

  selectCiudad(ciudad: Ciudad) {
    this.selectedCiudadText = ciudad.nombre;
    this.formBusqueda.get('ciudad').setValue(ciudad);
    this.ciudadesSeleccion(ciudad, true);
    this.toggleCiudad();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInside = target.closest('.custom-select-wrapper');

    if (!isInside && this.openedSelect !== '') {
      console.log("entro if select");
      const prevSelect = this.openedSelect;
      this.openedSelect = '';

      this.updateRotation(prevSelect);

      if (prevSelect === 'tipoInmueble' && !this.selectedTipoInmuebleText) {
        this.selectedTipoInmuebleText = '';
        this.formBusqueda.get('tipoInmueble').setValue('');
      }
      if (prevSelect === 'rango' && !this.selectedRangoText) {
        this.selectedRangoText = '';
        this.formBusqueda.get('rango').setValue(0);
      }
      if (prevSelect === 'estado' && !this.selectedEstadoText) {
        this.selectedEstadoText = '';
        this.formBusqueda.get('estado').setValue('');
      }
      if (prevSelect === 'ciudad' && !this.selectedCiudadText) {
        this.selectedCiudadText = '';
        this.formBusqueda.get('ciudad').setValue('');
      }
    }
  }
}
